import { Container, Col, Row, Button } from 'react-bootstrap';

function Contact(){
    return (
        <div id='Contact' style={{backgroundColor:'#eee'}}>
            <Container className='py-5'>
                <Row>
                    <Col>
                        
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='px-3 text-center'>
                            <h2>Tertarik bekerja Sama dengan kami?</h2>
                            <p>nunggu apalagi? hubungin kami untuk konsultasi lebih lanjut</p>
                            <a href='https://wa.me/+622081333570925' target='_blank' rel="noreferrer"><Button className='px-4'>Kontak Kami <i className='bi bi-arrow-right-short'></i></Button></a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Contact;